import { render, staticRenderFns } from "./giftAgent.vue?vue&type=template&id=9a9f68a6&scoped=true&"
import script from "./giftAgent.vue?vue&type=script&lang=js&"
export * from "./giftAgent.vue?vue&type=script&lang=js&"
import style0 from "./giftAgent.vue?vue&type=style&index=0&id=9a9f68a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9f68a6",
  null
  
)

export default component.exports